export const figure13a = {
    chart: {
        type: 'line',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
        plotBackgroundColor: null,
        plotBorderWidth: null,
      },
      credits: {
        enabled: false
    },
      title: {
        text: 'Malawi'
      },
      subtitle: {
        text: null
    },
      xAxis: {
        categories: ['2011','2013','2017', '2020']
      },
      labels: {
         style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      yAxis: {
        min: 0,
        max: 10,
        tickInterval: 5,
        title: {
            text: null,
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        }
    },
    legend: {
        enabled: false,
    },
      colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
      series: [{
        name: 'Petites exploitations',
        data: [4.4, 6.8, 4.0, 2.0,]
      }, {
        name: 'Autres exploitations',
        data: [7.4, 9.7, 5.4, 2.3,]
      },{
        name: 'Petites exploitations dirigées par une femme',
        data: [4.1, 6.8, 3.8, 1.8,]
      },{
        name: 'Petites exploitations dirigées par un homme',
        data: [4.5, 6.9, 4.1, 2.1,]
      }]
    }

    